import React from "react";
import "./Stay.css";
import { useTranslation } from "react-i18next";


interface StayProps {
  message?: string; // optional prop to allow customization
  total: number; // Total number of timer-reset elements (<=10)
  active: number; // Number of timer-reset elements to show in red
}

const Stay: React.FC<StayProps> = ({ message = "text", total=3, active=1 }: StayProps): React.JSX.Element => {

  const { t } = useTranslation(); // Use useTranslation hook
  const timerResets = Array.from({ length: total }, (_, index) => {
    const isRed = index < active;
    return (
      <img
        key={index}
        className="set_svg"
        alt="Timer reset"
        src={`/img/set.svg`}
        // Adjust color for non-red images
        style={{ filter: isRed ? 'none' : 'brightness(0) invert(1)' }}
      />
    );
  });


  return (
    <div className="gif">
      <div className="sets">{timerResets}</div>
      <div className="text">{t(`stay.${message}`)}</div>
    </div>
  );
};

export default Stay;